import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'

import { TidewaysContext } from '../../app/context'
import { Entity } from '../../app/entity'
import Navigator from '../../app/navigator'
import { BackendError } from '../../domain/BackendError'
import { TidewaysEvent } from '../../domain/Event'
import BoxBody from '../../helper/boxBody'
import Link from '../../helper/link'
import Shorten from '../../helper/shorten'
import { ApplicationState } from '../../redux/ApplicationState'

interface Data {
    events: TidewaysEvent[]
}

interface StateProps {
    navigator: Navigator
    parameters: { [key: string]: string }
    error: BackendError | null
    tidewaysContext: TidewaysContext
}

type Props = StateProps & Entity<Data>

class EventNavigator extends React.Component<Props> {
    public render() {
        return (
            <div className="box">
                <div className="box-header">
                    <nav className="navbar navbar-toolbar">
                        <div className="container-fluid">
                            <h3 className="box-title">Events</h3>

                            <div className="nav navbar-nav navbar-right btn-group btn-group-sm">
                                <Link route="XhprofProfilerBundle.Event.create" className="btn btn-primary">
                                    <span className="fa fa-plus" />
                                </Link>
                                <Link route="XhprofOrganizationBundle.Application.show" className="btn btn-default">
                                    <span className="fa fa-close" />
                                </Link>
                            </div>
                        </div>
                    </nav>
                </div>

                <BoxBody {...this.props} noPadding>
                    {!this.props.data || !this.props.data.events ? null : (
                        <ul className="nav nav-pills nav-stacked">
                            {Object.entries(this.props.data.events).map(([key, event]) => {
                                return (
                                    <li key={event.id} className={event.id === parseInt(this.props.parameters.event, 10) ? 'active' : ''}>
                                        <Link
                                            route="XhprofOrganizationBundle.Application.show"
                                            params={{ event: event.id, events: this.props.parameters.events }}
                                        >
                                            <big>
                                                <span className="label label-default">
                                                    {moment
                                                        .utc(event.eventDate)
                                                        .local()
                                                        .format('H:mm')}
                                                </span>{' '}
                                                {event.label}
                                            </big>
                                            <br />
                                            <Shorten string={event.name} />
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>
                    )}
                </BoxBody>
            </div>
        )
    }
}

export default connect<StateProps & Entity<Data>, {}>(
    (globalState: ApplicationState, props): Props => {
        const key = JSON.stringify(globalState.tidewaysContext.route.parameters.events)
        const list = globalState.events.list[key] || new Entity()

        return {
            tidewaysContext: globalState.tidewaysContext,
            navigator: new Navigator(globalState.tidewaysContext.route),
            parameters: globalState.tidewaysContext.route.parameters,
            ...list,
        }
    },
)(EventNavigator)
